export default __webpack_public_path__ + "open-sans-v18-latin-600.woff2";